<template>
  <div>
    <!-- 下拉单选控件 -->
    <el-select
      :size="size"
      style="width:100%"
      ref="selectOrgPersonPanel"
      v-model="selectOrgPersonName"
      placeholder="请选择"
      :disabled="selectDisabled"
      v-selectDisableClose
      @click.native="showOrgPersonDialog"
      multiple
      @remove-tag="removeTag"
    >
      <el-option
        :value="selectOrgPersonIds"
        style="height: auto;display:none;"
      > </el-option>
    </el-select>
    <el-dialog
      :visible.sync="showOrgPerson"
      append-to-body
      title="选择人员"
    :close-on-click-modal="false"
    >
      <div>
        <OrgTreeSelect
          :parentId="parentId"
          @getSelectValue="getSelectOrgValue"
          style="float:left;margin:0 0 0 10px;"
        ></OrgTreeSelect>
        <!--<el-input-->
          <!--placeholder="姓名"-->
          <!--v-model="filterName"-->
          <!--style="width:200px;float:left;margin:0 0 0 10px;"-->
        <!--&gt;</el-input>-->
        <el-input
          placeholder="工号/姓名/域账号"
          v-model="filterId"
          style="width:200px;float:left;margin:0 0 0 10px;"
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchPerson"
          style="width:100px;float:left;margin:0 0 0 10px;"
        >搜索</el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%;"
        @select="handleSelectionChange"
        @select-all="handleAllSelectionChange"
        v-loading="tableLoading"
      >
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="OGU_GUID"
          label="工号"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="OGU_NAME"
          label="姓名"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="ORG_NAME"
          label="上级组织"
          width="200"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="OGU_EMAIL"
          label="邮箱"
          width="100"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column
          prop="IS_CRM"
          label="用户类型"
          width="100"
          show-overflow-tooltip
          :formatter="crmFormat"
        >
        </el-table-column>
      </el-table>
      <div>
        <el-button
          type="primary"
          @click="confirmSelection()"
          style="float:left;"
        >确定</el-button>
        <el-button
          @click="clearSelection()"
          type="primary"
          style="float:left;margin:0 0 0 10px;"
        >清空全部选择</el-button>
        <el-pagination
          :background="pageBackground"
          layout="prev, pager, next"
          @current-change="handleCurrentPageChange"
          :total="totalRecords"
          :page-size="pageSize"
          :current-page="pageIndex"
        ></el-pagination>
      </div>
    </el-dialog>

  </div>
</template>
<script>
//引入多选控件
import OrgTreeSelect from "../plugins/OrgTreeSelect"
export default {
  data() {
    return {
      tableLoading:true,
      showOrgPerson: false, //是否显示驳回窗口
      selectOrgPerson: [],
      selectOrgPersonName: "",
      selectOrgPersonIds: "",
      loading: true,
      tableData: [],
      pageBackground: true,
      pageSize: 8,
      pageIndex: 1,
      totalRecords: 0,
      filterName: "",
      filterId: "",
      filterOrg: [],
      visibleChange: false,
    };
  },
  directives: {
    selectDisableClose: {
      componentUpdated: function (el, bindings, vnode) {
        const dealStyle = function (tags) {
          tags.forEach((el, index) => {
            if (![el.classList].includes("select-tag-close-none")) {
              el.classList.add("select-tag-close-none");
            }
          });
        };
        setTimeout(() => {
          const tagTemp = el.querySelectorAll(".el-tag__close");
          dealStyle(tagTemp);
        });
      },
    },
  },
  props: {
    mulitpleLimit:{
      type:Number,
      default:8
    },
    initValue: Array,
    multipleSelect: Boolean,
    selectDisabled: Boolean,
    parentId: String,
    indexSelect: Number,
    size: String,
  },
  created() {
    this.initOrgPerson();
  },
  mounted() {
  },
  methods: {
    showOrgPersonDialog() {
      if (!this.selectDisabled) {
        this.showOrgPerson = true;
        this.loadOrgPerson();
        this.$refs.selectOrgPersonPanel.blur();
      }

    },
    //多选变动后的回调函数，修改selectValue数组
    getSelectOrgValue(val) {
      console.log(val);
      this.filterOrg = val;
    },
    //页码改变
    handleCurrentPageChange(val) {
      this.pageIndex = val;
      this.loadOrgPerson();
    },
    removeTag(v){
      if(!this.multipleSelect){
        this.tableData.forEach((item) => {
          this.$refs.multipleTable.toggleRowSelection(item, false);
        });
        this.selectOrgPerson = []
      }else{
        this.selectOrgPerson = this.selectOrgPerson.filter(item=>{
          return item.name != v
        })
      }
      this.reBuildSelectOrgNameAndIds();
      if (this.indexSelect || this.indexSelect == 0) {
        this.$emit("getSelectValue", this.selectOrgPersonIds + "-" + this.indexSelect,);
      } else {
        this.$emit("getSelectValue", this.selectOrgPersonIds,this.selectOrgPersonName);
        // this.$emit("getSelectValueId",)
      }
    },
    handleSelectionChange(rows, row) {
      //如果是单选
      let selected = rows.length && rows.indexOf(row) !== -1
      if (!this.multipleSelect) {
        this.selectOrgPersonName = "";
        this.selectOrgPersonIds = "";
        this.selectOrgPerson = [];
        console.log(row)
        //其他选项都定为失效
        this.tableData.forEach((item) => {
          if (selected && item == row) {
            this.$refs.multipleTable.toggleRowSelection(item, true);
          } else {
            this.$refs.multipleTable.toggleRowSelection(item, false);
          }

        });
      }
      
      if (selected) {
        let addRow = true;
        for (let i = 0; i < this.selectOrgPerson.length; i++) {
          let orgPerson = this.selectOrgPerson[i];
          if (orgPerson.id == row.OGU_GUID) {
            addRow = false;
            break;
          }
        }
        if (addRow) {
          let orgPerson = [];
          orgPerson['id'] = row.OGU_GUID;
          orgPerson['name'] = row.OGU_NAME;
          this.selectOrgPerson.push(orgPerson);
        }
      } else {
        let selectOrgPersonNew = [];
        for (let i = 0; i < this.selectOrgPerson.length; i++) {
          let orgPerson = this.selectOrgPerson[i];
          if (orgPerson.id != row.OGU_GUID) {
            selectOrgPersonNew.push(orgPerson);
          }
        }
        this.selectOrgPerson = selectOrgPersonNew;
      }

      this.reBuildSelectOrgNameAndIds();
      console.log(this.selectOrgPersonIds)
      //this.$emit("getSelectValue", this.selectOrgPersonIds);
      if (this.indexSelect || this.indexSelect == 0) {
        this.$emit("getSelectValue", this.selectOrgPersonIds + "-" + this.indexSelect,);
      } else {
        this.$emit("getSelectValue", this.selectOrgPersonIds,this.selectOrgPersonName);
        // this.$emit("getSelectValueId",)
      }
    },
     handleAllSelectionChange(rows) {
      //如果是全选
      console.log(this.selectOrgPerson)
      if (rows.length>0) {
        for(const row of rows){
          this.addOrgPerson(row);
        }
      }

      // this.reBuildSelectOrgNameAndIds();
      //this.$emit("getSelectValue", this.selectOrgPersonIds);
      if (this.indexSelect || this.indexSelect == 0) {
        this.$emit("getSelectValue", this.selectOrgPersonIds + "-" + this.indexSelect,);
      } else {
        this.$emit("getSelectValue", this.selectOrgPersonIds,this.selectOrgPersonName);
        // this.$emit("getSelectValueId",)
      }
    },
    
    //confirm selection
    confirmSelection() {
      this.showOrgPerson = false;
    },
    //clear selection
    clearSelection() {
      this.selectOrgPersonName = [];
      this.selectOrgPersonIds = [];
      this.selectOrgPerson = [];
      this.initValue = [];
      if (this.indexSelect || this.indexSelect == 0) {
        this.$emit("getSelectValue", this.selectOrgPersonIds + "-" + this.indexSelect);
      } else {
        this.$emit("getSelectValue", this.selectOrgPersonIds);
      }
      this.$refs.multipleTable.clearSelection();
      this.showOrgPerson = false;
    },
    searchPerson() {
      this.pageIndex = 1;
      this.loadOrgPerson();
    },
    loadOrgPerson() {
      this.tableLoading = true;
      this.tableData = [];
      // let wStr = "";
      let wForm = {}
      // if (this.filterOrg.length > 0) {
      //   wStr += " and ORG_GUID='" + this.filterOrg[0] + "'";
      // }
      if (this.filterId) {
        // wStr += " and OGU_GUID like  '%" + this.filterId + "%'";
        wForm.oguGuidLike = this.filterId
      }
      if (this.filterName) {
        // wStr += " and OGU_NAME like '%" + this.filterName + "%'";
        wForm.oguNameLike = this.filterName
      }
      let orgFilterGuid="";
      if(!this.filterOrg[0]){
        orgFilterGuid="";
        //orgFilterGuid=this.parentId; //这个会变慢，但逻辑对
      }else{
        orgFilterGuid=this.filterOrg[0];
      }
      this.$axios
        .get("/api/orgPerson/v0.1/orgPerson/getOrgPersonListByPage", {
          params: {
            orgGuid: orgFilterGuid,
            page: this.pageIndex,
            pagesize: this.pageSize,
            wForm:encodeURIComponent(JSON.stringify(wForm))
          },
        })
        .then((res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.tableData = js.data.list;
            this.totalRecords = js.data.count;
            let that = this;
            that.$nextTick(function () {
              that.tableData.forEach((row) => {
                if (this.selectOrgPersonIds.indexOf(row.OGU_GUID) >= 0) {
                  that.$refs.multipleTable.toggleRowSelection(row, true);
                }
              })
            })
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
    },
    //initialize OrgPerson 
    initOrgPerson() {
      if (this.initValue == null || this.initValue.length == 0) {
         this.selectOrgPerson = [];
         this.selectOrgPersonName=[];
          this.selectOrgPersonIds = [];
        return;
      }
      this.tableLoading = true;
      // this.tableData = [];
      this.selectOrgPerson = [];
      this.selectOrgPersonName = "";
      this.selectOrgPersonIds = "";
      let wForm = {}
      if (this.initValue.length > 0) {
        // wStr += " and OGU_GUID in ('" + this.initValue.join("','") + "')";
        wForm.oguGuids = this.initValue
      }
      this.$axios
        .get("/api/orgPerson/v0.1/orgPerson/getOrgPersonListByPageShow", {
          params: {
            orgGuid: "", //赋值时候，不提供机构ID
            page: 1,
            pagesize: this.mulitpleLimit,
            wForm:encodeURIComponent(JSON.stringify(wForm))
          },
        })
        .then((res) => {
          var js = res.data;
          if (js.errcode == 0) {
            let arrLabel = [];
            let arrValue = [];

            if(this.initValue == null || this.initValue.length == 0){
              this.selectOrgPerson = [];
         this.selectOrgPersonName=[];
          this.selectOrgPersonIds = [];
            }else{
              js.data.list.forEach((item) => {
              this.addOrgPerson(item);
            });
            }
            
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });

    },
    addOrgPerson(item) {
      if (item) {
        let addRow = true;
        for (let i = 0; i < this.selectOrgPerson.length; i++) {
          let orgPerson = this.selectOrgPerson[i];
          if (orgPerson.id == item.OGU_GUID) {
            addRow = false;
            break;
          }
        }
        if (addRow) {
          let orgPerson = [];
          orgPerson['id'] = item.OGU_GUID;
          orgPerson['name'] = item.OGU_NAME;
          this.selectOrgPerson.push(orgPerson);
          this.reBuildSelectOrgNameAndIds();
        }
      }
    },
    reBuildSelectOrgNameAndIds() {
      let arrLabel = [];
      let arrValue = [];
      if (this.selectOrgPerson && this.selectOrgPerson.length > 0) {
        this.selectOrgPerson.forEach(orgPerson => {
          arrLabel.push(orgPerson.name);
          arrValue.push(orgPerson.id);
        })

      }
      this.selectOrgPersonName = arrLabel;
      this.selectOrgPersonIds = arrValue;
    },
    crmFormat(row){
      let tempName = '';
      switch(row.IS_CRM){
          case 1:
              tempName="代理商";
              break;
          case 0:
              tempName="集团用户";
              break;
      }
      
      return tempName;
    }

  },
  watch: {
    initValue() {
      this.initOrgPerson();
    },

  },
  //注册组件
  components: {
    OrgTreeSelect, //组织树
  },
};
</script>
<style  scoped>
.el-select-dropdown__item {
  padding: 0 0 0 0;
}
.none {
  display: none;
}
</style>
